/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import {observer, inject} from 'mobx-react';

/**************************************** PROJECT MODULES *****************************************/
import {StoreProps, translate} from '@canimmunize/core-imports';

/**************************************** TYPE DEFINITIONS ****************************************/
interface NavAwayPromptProps extends StoreProps {}

/********************************************* EXPORT *********************************************/
/**
 * Show confirm prompt when navigating away from page where data is currently
 * saving
 */
@inject('appState')
@observer
export class NavAwayPrompt extends React.Component<NavAwayPromptProps> {
    /**
     * On mount, attach listeners that display confirm prompt on page exit
     */
    componentDidMount() {
        window.onbeforeunload = () => {
            const {appState} = this.props;
            if (
                (appState.hasInitialized && appState.jvlnsBroadcaster.pendingRequests !== 0) ||
                appState.hasUnsavedData ||
                appState.uiStore.createNewRecordStore.hasChanged
            ) {
                return translate(`warning_unsaved_changes`);
            }
        };
    }

    /**
     * On unmount, detach listeners for page exit
     */
    componentWillUnmount() {
        window.onbeforeunload = null;
    }

    render() {
        return null;
    }
}
